import { Optional } from '@/types/common'

function* range(start, end) {
  for (let i = start; i <= end; i++) {
    yield i
  }
}

export function getControlledDaysChartOptions(controlledDays: Optional<number>, uncontrolledDays: Optional<number>) {
  if (controlledDays == null || uncontrolledDays == null) {
    return {} // TODO, somehow if return null caused v-else renter incorrectly
  }

  const max = Math.max(30, controlledDays, uncontrolledDays)

  return {
    xAxis: {
      data: [...range(0, max)],
      type: 'value',
      axisLine: { show: false },
      axisTick: {
        show: false,
      },
      splitLine: { show: false },
      axisLabel: {
        show: false,
      },
      min: 0,
      max: max,
    },
    yAxis: {
      type: 'category',
      axisLine: { show: false },
      splitLine: { show: false },
      data: ['empty1', 'uncontrolled', 'empty2', 'controlled'],
      axisLabel: {
        show: true,
        align: 'left',
        margin: 0,
        padding: [0, 0, 20, 0],
        formatter: name => {
          if (name === 'empty1') {
            return `${uncontrolledDays} Days Uncontrolled`
          }

          if (name === 'empty2') {
            return `${controlledDays} Days Controlled`
          }
        },
        fontWeight: 'bold',
        fontFamily: 'Source Sans Pro',
        fontSize: 14,
        color: '#74777a',
      },
    },
    series: [
      {
        type: 'bar',
        barWidth: 24,
        label: { show: false },
        itemStyle: {
          color: '#5fd0d0',
          barBorderRadius: 4,
        },
        // @ts-ignore
        data: [
          {
            value: 0,
          },
          {
            value: uncontrolledDays,
            itemStyle: {
              color: '#9a3f67',
            },
          },
          {
            value: 0,
          },
          {
            value: controlledDays,
            itemStyle: {
              color: '#5fd0d0',
            },
          },
        ],
      },
    ],
    tooltip: {
      show: true,
      // IMPORTANT force newline been treated accordingly
      extraCssText: 'white-space:pre-wrap',
      formatter: function(params) {
        const { name } = params
        if (name === 'uncontrolled') {
          return (
            'Patient experienced \n' +
            'Shortness Of Breath, \n' +
            'Exacerbations or increased \n' +
            'in rescue inhaler usage \n'
          )
        }
      },
    },
  }
}
